// extracted by mini-css-extract-plugin
export default {"button":"Zt","primary":"au","fullWidth":"bu","secondary":"cu","nutrition":"eu","underlined":"fu","small":"gu","medium":"hu","info":"iu","white":"ju","border":"ku","mango":"lu","charcoal":"mu","court":"nu","green":"ou","spark":"pu","linkButton":"qu","disabled":"ru"};
    if(module.hot) {
      // 1715188229815
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  